export default "__VITE_ASSET__DvPOYk1J__"